import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, X } from "lucide-react";
import logoTitle from "@/assets/logo-titre.png.asset.json";
import logoEmblem from "@/assets/logo-fleur.png.asset.json";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/a-propos", label: "À propos" },
  { to: "/prestations", label: "Prestations" },
  { to: "/prestations", hash: "bons-cadeaux", label: "Pour offrir" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
] as const;

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background/95 backdrop-blur-md border-b border-border"
          : "bg-background/60 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-6 py-2.5 md:py-3">
        <Link to="/" className="flex items-center gap-3" aria-label="Rénergescence — Accueil">
          <img src={logoEmblem.url} alt="" width={56} height={56} className="h-12 w-12 object-contain md:h-14 md:w-14" />
          <div className="flex flex-col leading-none">
            <img src={logoTitle.url} alt="Rénergescence" width={140} height={22} className="h-[18px] w-auto md:h-[22px]" />
            <span className="mt-1 hidden text-[9px] uppercase tracking-[0.22em] md:block" style={{ color: "#6a6258" }}>
              Santé naturelle &amp; bien-être
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-5 md:flex">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              hash={(l as { hash?: string }).hash}
              className="text-[11px] font-normal uppercase tracking-[0.18em] transition-colors hover:opacity-70"
              style={{ color: "var(--color-text)" }}
              activeProps={{ style: { color: "var(--color-sage-text)" } }}
              activeOptions={{ exact: l.to === "/" }}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-2 rounded-full px-5 py-2 text-[11px] font-medium uppercase tracking-[0.14em] text-white transition-opacity hover:opacity-90"
            style={{ backgroundColor: "var(--color-sage)" }}
          >
            Prendre rendez-vous
          </Link>
        </nav>

        <button
          className="relative z-[110] md:hidden text-foreground"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>

    {open && (
      <div
        className="fixed inset-0 z-[100] flex flex-col px-8 pb-10 pt-24 md:hidden"
        style={{ backgroundColor: "#F8F5F0" }}
      >
        <nav className="flex flex-1 flex-col items-center justify-center gap-1">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              hash={(l as { hash?: string }).hash}
              onClick={() => setOpen(false)}
              className="py-4 font-display text-3xl font-light"
              style={{ color: "#2D2B28" }}
              activeProps={{ style: { color: "var(--color-sage-text)", fontStyle: "italic" } }}
              activeOptions={{ exact: l.to === "/" }}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <Link
          to="/contact"
          onClick={() => setOpen(false)}
          className="inline-flex min-h-[52px] items-center justify-center rounded-full px-8 text-[13px] font-medium uppercase tracking-[0.16em] text-white"
          style={{ backgroundColor: "#7A8A76" }}
        >
          Prendre rendez-vous
        </Link>
      </div>
    )}
    </>
  );
}
